import { useCallback } from "react";

import type { InternalApiKeysTranslations } from "@/shared/lang/interfaces/internalApiKeys";
import useTranslations from "@/shared/lang/useTranslations";

import { PERMISSION_LABEL_KEYS } from "../constants/internalApiKeys.constants";
import type { InternalApiKeyPermission } from "../types/internalApiKeys.types";

// A permission the backend added after this build has no label yet: its code is still readable.
export function usePermissionLabel() {
  const { t } = useTranslations("internalApiKeys");
  return useCallback(
    (permission: InternalApiKeyPermission) => {
      const key: keyof InternalApiKeysTranslations | undefined = PERMISSION_LABEL_KEYS[permission];
      return key ? t(key) : permission;
    },
    [t],
  );
}
